<template>
  <div class="place-row">
    <div class="place-info1">
      <div class="p-title" v-if="locationSearchView">
        Tint World #{{ store["location-id"] }}
      </div>
      <div class="p-address1">
        {{ store.address.street }} {{ store.address.street2 }}
      </div>
      <div class="p-address2 md-b15">
        {{ store.address.city }}, {{ store.address.region }}
        {{ store.address.postalCode }}
      </div>
      <div class="p-contact c-blue c-pointer">
        {{ store.mainPhone }}
      </div>
      <div class="mobile-place-info2">
        <div class="text-bold p-time c-green">
          Open Until {{ store.currentHours }}
        </div>
        <div class="p-distance md-b15">
          {{ store.distance.distanceMiles.toFixed(1) }} Miles |
          <span
            class="c-blue c-pointer"
            @click.stop="goToNewTabLink(store.directionsURL)"
            >Get Directions</span
          >
        </div>
        <div
          class="p-contact c-blue c-pointer details-btn"
          @click.stop="showDetail(store)"
          v-if="!locationSearchView"
        >
          See Store Details
        </div>
        <div class="p-contact c-blue c-pointer details-btn" v-else>
          <a :href="store.websiteUrl">See Store Details</a>
        </div>
      </div>
    </div>
    <div class="place-info2">
      <div class="text-bold p-time c-green">
        Open Until {{ store.currentHours }}
      </div>
      <div class="p-distance md-b15">
        {{ store.distance.distanceMiles.toFixed(1) }} Miles |
        <span
          class="c-blue c-pointer"
          @click.stop="goToNewTabLink(store.directionsURL)"
          >Get Directions</span
        >
      </div>
      <div
        class="p-contact c-blue c-pointer details-btn"
        @click.stop="showDetail(store)"
        v-if="!locationSearchView"
      >
        See Store Details
      </div>
      <div class="p-contact c-blue c-pointer details-btn" v-else>
        <a :href="store.websiteUrl">See Store Details</a>
      </div>
    </div>
    <div class="place-info3">
      <div class="heart-area active c-pointer" v-if="isMyStore">
        <i aria-hidden="true" class="fa fa-heart"></i>
        <p>My</p>
        <p>Store</p>
      </div>
      <div
        class="heart-area c-pointer"
        v-else
        @click.stop="setStore(store['location-id'])"
      >
        <i aria-hidden="true" class="fa fa-heart-o"></i>
        <p>Set as</p>
        <p>My Store</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SingleStoreSearchResult",
  props: {
    setStore: Function,
    store: Object,
    locationSearchView: {
      type: Boolean,
      default: false,
    },
    isMyStore: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      selectedStore: null,
    };
  },
  computed: {},
  methods: {
    goToNewTabLink(url) {
      this.$emit("goToNewTabLink", url);
    },
    showDetail(item) {
      this.$emit("showDetail", item);
    },
  },
};
</script>
